import React, { useEffect, useState } from "react";

import { makeStyles, withStyles } from "@material-ui/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Hidden from "@material-ui/core/Hidden";
import Pagination from "@material-ui/lab/Pagination";
import { connectRange } from "react-instantsearch-dom";

import PlaceCard from "./PlaceCard";
import PriceInput from "./PriceInput";

const PAGE_SIZE = 20;

const useStyles = makeStyles((theme) => ({
  root: {},
  places: {},
  placeContainer: {
    width: "100%",
    backgroundColor: "#fafafa",
  },
  price: {
    display: "flex",
  },
  sticky: {
    top: 56,
    [`${theme.breakpoints.up("xs")} and (orientation: landscape)`]: {
      top: 48,
    },
    [theme.breakpoints.up("sm")]: {
      top: 64,
    },
  },
  grid: {
    backgroundColor: "white",
    display: "grid",
    width: "100%",
    padding: theme.spacing(1),
    gridTemplateColumns: "98%",
    gridGap: theme.spacing(1),
    alignContent: "space-evenly",
    justifyContent: "center",
    [theme.breakpoints.up("lg")]: {
      gridTemplateColumns: "49% 49%",
    },
  },
  bar: {
    backgroundColor: "white",
    color: "black",
    boxShadow: "none",
    borderBottom: `solid 1px ${theme.palette.primary.main}`,
  },
  pagination: {
    marginBottom: theme.spacing(4),
    marginTop: theme.spacing(4),
  },
  paginationContainer: {
    display: "flex",
    justifyContent: "center",
    backgroundColor: "white",
  },
  showingNumber: {
    marginLeft: theme.spacing(3),
  },
}));

const Places = ({
  listings = [],
  selectedPlace,
  setSelectedPlace,
  setHighlightPlace,
  currentRefinement,
  refine,
}) => {
  const classes = useStyles();
  let selectedId = null;
  if (selectedPlace) selectedId = selectedPlace.objectID;

  let initialIndex = 0;
  let selectedIndex = 0;
  if (selectedId) {
    for (let i = 0; i < listings.length; i++) {
      let place = listings[i];
      if (place.objectID == selectedId) {
        initialIndex = Math.floor(i / PAGE_SIZE);
        selectedIndex = i % PAGE_SIZE;
      }
    }
  }

  const [startIndex, setStartIndex] = React.useState(initialIndex);
  const pageCount = Math.ceil(listings.length / PAGE_SIZE);
  let pageListings = listings.slice(
    initialIndex * PAGE_SIZE,
    (initialIndex + 1) * PAGE_SIZE
  );
  const onPage = (event, value) => {
    setStartIndex(value - 1);
    setSelectedPlace(listings[(value - 1) * PAGE_SIZE]);
  };

  const refs = pageListings.reduce((acc, value, index) => {
    if (!value) return null;
    acc[index] = React.createRef();
    return acc;
  }, {});

  React.useEffect(() => {
    if (!selectedId) return;
    let ref = refs[selectedIndex].current;
    if (!ref) return;

    ref.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
    // don't include refs otherwise it'll always scroll
  }, [selectedId]); // eslint-disable-line

  return (
    <div className={classes.root}>
      <AppBar
        position="sticky"
        className={classes.bar}
        classes={{
          positionSticky: classes.sticky,
          colorPrimary: classes.app,
        }}
      >
        <Hidden smDown implementation="css">
          <Typography className={classes.showingNumber}>
            Right click on map to make a new video!
          </Typography>
          <Typography className={classes.showingNumber}>
            Showing {pageListings.length} of {listings.length}.
          </Typography>
        </Hidden>
      </AppBar>
      {listings.length === 0 ? (
        <div className={classes.grid}>
          <Typography>No videos found.</Typography>
        </div>
      ) : (
        <>
          <div className={classes.grid}>
            {pageListings.map((node, index) => {
              return (
                <div
                  role="button"
                  tabIndex={index}
                  onMouseOver={() => {
                    setHighlightPlace(node);
                  }}
                  onFocus={() => {
                    setHighlightPlace(node);
                  }}
                  onMouseOut={() => {
                    setHighlightPlace(null);
                  }}
                  onBlur={() => {
                    setHighlightPlace(null);
                  }}
                  onClick={() => {
                    setSelectedPlace(node);
                  }}
                  className={classes.placeContainer}
                  ref={refs[index]}
                  key={node.objectID}
                >
                  <PlaceCard
                    id={node.objectID}
                    node={node}
                    selected={selectedId === node.objectID}
                    priceRefinement={currentRefinement}
                  />
                </div>
              );
            })}
          </div>
          <div className={classes.paginationContainer}>
            <Pagination
              count={pageCount}
              color="primary"
              onChange={onPage}
              className={classes.pagination}
              page={initialIndex + 1}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default connectRange(Places);
//export default Places;
